import { writable, get } from 'svelte/store';

export const contactIsOpen = writable(false);

const createWritableStore = (key, startValue) => {
    const { subscribe, set } = writable(startValue);

    return {
        subscribe,
        set,
        useLocalStorage: () => {
            const json = localStorage.getItem(key);
            if (json) {
                set(JSON.parse(json));
            }

            subscribe(current => {
                localStorage.setItem(key, JSON.stringify(current));
            });
        }
    };
}

function deleteStores(tPath, key) {
    for (var key2 in tPath[key]) {
        for (var key3 in tPath[key][key2]) {
            //console.log("-------------- key2 " + key2 + " has value :" + tPath[key][key2]);
            let storeName = eval(tPath[key][key2][key3]);
            //eval(namestore);
            // console.log(get(storeName));
            // console.log(get(storeName)));
            storeName.set();
            //storeName = 'zzzz';
        }
    }
}

function updateStores(loc, tPath, key) {
    let newTPath = [];
    let kfound = false;
    for (var key in tPath) {
        if (kfound === false) {
            if (key == loc) {
                // console.log("------- KEY TROUVE " + key + " has value :");
                // console.log(tPath[key]);
                newTPath[key] = tPath[key];
                kfound = true;

            } else {
                // console.log("------- key " + key + " has value :");
                // console.log(tPath[key]);
                newTPath[key] = tPath[key];
            }
        } else {
            // console.log("------- key DELETE " + key + " ");
            // console.log(get(nomTrappe));
            // console.log(tPath[key]);
            deleteStores(tPath, key);

        }
    }
    console.log(newTPath);
    return newTPath;

}

export const currentLocation = writable('');

function createPathTrappe() {
    const { subscribe, set, update } = writable([]);
    return {
        subscribe,
        add: (loc, items) => {
            const arr = [];
            arr[loc] = items;
            update(value => {
                value[loc] = arr;
                return value;
            });
            update(tPath => {
                return updateStores(loc, tPath);
            });
        },
        remove: (loc) => {
            update(tPath => {
                return updateStores(loc, tPath);
            });
        },
        empty: () => set([])
    };
}

export const pathTrappe = createPathTrappe();

// export const idTrappe = createWritableStore('idTrappe', '');
// export const nomTrappe = createWritableStore('nomTrappe', '');
// export const choix = createWritableStore('choix', '');

// const stored = localStorage.idTrappe
// export const idTrappe = writable(stored || '')
// idTrappe.subscribe((idTrappe) => localStorage.idTrappe = idTrappe)

// const storednomTrappe = localStorage.nomTrappe
// export const nomTrappe = writable(storednomTrappe || '')
// nomTrappe.subscribe((nomTrappe) => localStorage.nomTrappe = nomTrappe)

// const storedtype = localStorage.type
// export const type = writable(storedtype || '')
// type.subscribe((type) => localStorage.type = type)

// Can be pro  or part (but not negociant)
export const finalType = writable(false);
export const idDb = writable('');

export const isPhone = writable(false);
export const alertReload = writable(false);

export const sketchfabId = writable('');
export const linkPdfId = writable('');
export const idTrappe = writable('');
export const nomTrappe = writable('');
export const choix = writable('');
export const dimLongueur = writable('');
export const dimLargeur = writable('');
export const sensOuverture = writable('');
export const fermeture = writable('');
export const type = writable('');
export const couleur = writable('');
export const epaisseur = writable('');
export const dureeResistance = writable('');
export const trappePath = writable([]);
export const dimLongueurIdFiche = writable('');
export const dimLargeurIdFiche = writable('');
export const sensOuvertureIdFiche = writable('');
export const fermetureIdFiche = writable('');
export const typeIdFiche = writable('');
export const couleurIdFiche = writable('');
export const epaisseurIdFiche = writable('');
export const dureeResistanceIdFiche = writable('');
export const idBtnCoupeFeu = writable('');
export const idBtnCoupeFeuPlafond = writable('');
export const idBtnCoupeFeuPlafondResistance = writable('');
export const idBtnCoupeFeuPlafondEpaisseur = writable('');
export const idBtnCoupeFeuCloison = writable('');
export const idBtnCoupeFeuCloisonResistance = writable('');
export const idBtnCoupeFeuCloisonEpaisseur = writable('');
export const coupeFeuIdPath = writable('');
export const quantite = writable('1');
export const commentaire = writable('');

export const trappes = writable({
    sketchfabId,
    linkPdfId,
    idTrappe,
    nomTrappe,
    choix,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    type,
    couleur,
    epaisseur,
    dureeResistance,
    dimLongueurIdFiche,
    dimLargeurIdFiche,
    sensOuvertureIdFiche,
    fermetureIdFiche,
    typeIdFiche,
    couleurIdFiche,
    epaisseurIdFiche,
    dureeResistanceIdFiche,
    coupeFeuIdPath,
    trappePath,
    quantite,
    commentaire,
    idBtnCoupeFeu,
    idBtnCoupeFeuPlafond,
    idBtnCoupeFeuPlafondResistance,
    idBtnCoupeFeuPlafondEpaisseur,
    idBtnCoupeFeuCloison,
    idBtnCoupeFeuCloisonResistance,
    idBtnCoupeFeuCloisonEpaisseur,
});

export const coordonnees = writable({
    asNom: '',
    asPrenom: '',
    asEmail: '',
    asTel: '',
    asAdresse: '',
    asCp: '',
    asVille: '',
    asPays: '',
    asRevendeur: '',
    asNewsletter: 'false'
});

export const coordonneesProfessionel = writable({
    asTypeSoc: '',
    asNomSoc: '',
    asActiviteSoc: '',
    asSiretSoc: '',
    asNom: '',
    asPrenom: '',
    asEmail: '',
    asTel: '',
    asAdresse: '',
    asCp: '',
    asVille: '',
    asPays: '',
    asRevendeur: '',
    asNewsletter: 'false'
});

export const coordonneesNegociant = writable({
    asId: '',
    asCode: '',
    asNomSoc: '',
    asAdresseSoc: '',
    asCpSoc: '',
    asVilleSoc: '',
    asReferenceSoc: '',
    asNewsletter: 'false'
});

export const contact = writable({
    contactNom: '',
    contactPrenom: '',
    contactTel: '',
    contactEmail: '',
    contactCp: '',
    contactNomSoc: '',
    contactDemande: '',
    contactType: '',
    contactMessage: ''
});

export let parentOptions = writable([{
        id: "1",
        text: `Distributeur`,
        children: [
            { id: "a1", text: `Négoce Matériaux Généraliste` },
            { id: "a2", text: `Négoce PPI` },
            { id: "a3", text: `Négoce Spécialiste Carrelage` },
            { id: "a4", text: `Négoce Spécialiste Sanitaire – Chauffage` },
            // { id: 5, text: `Marché Industriel ` },
            { id: "a6", text: `Coopérative` },
            { id: "a7", text: `Marché Industriel` },
            { id: "a8", text: `Grossiste Peintre` },
            { id: "a9", text: `QUOFI` },
            { id: "a10", text: `GSB` }
        ]
    },
    {
        id: "2",
        text: `Applicateur`,
        children: [
            { id: "b1", text: `TCE` },
            { id: "b2", text: `Plâtrerie – isolation` },
            { id: "b3", text: `Peinture` },
            { id: "b4", text: `Façade` },
            { id: "b5", text: `Carrelage` },
            { id: "b6", text: `Autre` },
        ]
    },
    {
        id: "3",
        text: `Prescripteur`,
        children: [
            { id: "c1", text: `Architecte` },
            { id: "c2", text: `Constructeur de maison` },
            { id: "c3", text: `Autre` }
        ]
    }
]);
export let selectedParent = writable(Object.values(get(parentOptions))[0]);
export let selectedChild = writable(Object.values(get(parentOptions))[0].children[0]); // ]